(function () {
  'use strict';

  var STORAGE_KEY = 'hriam_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isWishlisted(productId) {
    return getWishlist().some(function (p) { return p.id === productId; });
  }

  function toggleWishlist(product) {
    var list = getWishlist();
    var idx = list.findIndex(function (p) { return p.id === product.id; });
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push(product);
    }
    saveWishlist(list);
    return idx < 0;
  }

  function removeFromWishlist(productId) {
    saveWishlist(getWishlist().filter(function (p) { return p.id !== productId; }));
  }

  function updateHeartButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var id = parseInt(btn.dataset.productId, 10);
      var wishlisted = isWishlisted(id);
      btn.classList.toggle('is-wishlisted', wishlisted);
      btn.setAttribute('aria-label', wishlisted ? 'Remove from love list' : 'Add to love list');
      btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    });
  }

  function updateHeaderCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function renderDrawerBody() {
    var list = getWishlist();
    var body = document.querySelector('[data-wishlist-drawer-body]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!body) return;

    if (list.length === 0) {
      body.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }

    if (empty) empty.style.display = 'none';

    body.innerHTML = list.map(function (product) {
      return '<div class="wishlist-item" data-wishlist-item="' + product.id + '">' +
        '<a href="' + product.url + '" class="wishlist-item__image">' +
          '<img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" width="80" height="80" loading="lazy">' +
        '</a>' +
        '<div class="wishlist-item__info">' +
          '<a href="' + product.url + '" class="wishlist-item__title">' + escapeHtml(product.title) + '</a>' +
          '<p class="wishlist-item__price">' + escapeHtml(product.price) + '</p>' +
        '</div>' +
        '<button class="wishlist-item__remove" data-remove-wishlist="' + product.id + '" aria-label="Remove from love list">' +
          '&times;' +
        '</button>' +
      '</div>';
    }).join('');

    body.querySelectorAll('[data-remove-wishlist]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFromWishlist(parseInt(btn.dataset.removeWishlist, 10));
        renderDrawerBody();
        updateHeartButtons();
        updateHeaderCount();
      });
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-wishlist-drawer]');
    var overlay = document.querySelector('[data-wishlist-overlay]');
    if (!drawer) return;
    renderDrawerBody();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-wishlist-drawer]');
    var overlay = document.querySelector('[data-wishlist-overlay]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateHeartButtons();
    updateHeaderCount();

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-wishlist-toggle]')) {
        e.preventDefault();
        openDrawer();
        return;
      }

      if (e.target.closest('[data-wishlist-drawer-close]')) {
        closeDrawer();
        return;
      }

      if (e.target.closest('[data-wishlist-overlay]')) {
        closeDrawer();
        return;
      }

      var heartBtn = e.target.closest('[data-wishlist-btn]');
      if (heartBtn) {
        e.preventDefault();
        var product = {
          id: parseInt(heartBtn.dataset.productId, 10),
          handle: heartBtn.dataset.productHandle,
          title: heartBtn.dataset.productTitle,
          price: heartBtn.dataset.wishlistPrice,
          image: heartBtn.dataset.productImage,
          url: heartBtn.dataset.productUrl
        };
        toggleWishlist(product);
        updateHeartButtons();
        updateHeaderCount();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  });
})();
